import * as S from './AuthorPage.styles';

export const AuthorsLinks = ({ links }: { links: Record<string, string> }) => {
    return (
        <S.SocialLinks>
            {Object.keys(links).map((i, idx) =>
                links[i] ? (
                    <a key={idx} href={links[i]} target="__blank" rel="noffolow">
                        <img
                            height={36}
                            width={36}
                            style={{ display: 'block' }}
                            alt={links[i]}
                            src={`/social/authors/${i}.svg`}
                            loading="lazy"
                        />
                    </a>
                ) : null
            )}
        </S.SocialLinks>
    );
};
